import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FileArchive } from "lucide-react";
import { lazy } from "react";

const DocumentManager = lazy(() =>
  import("@features/rh/documents/components/DocumentManager").then((m) => ({
    default: m.DocumentManager,
  })),
);

export const Route = createFileRoute("/_app/rh/documents/")({
  loader: requirePermission(PERMISSIONS.RH.DOCUMENTS.VIEW),
  staticData: {
    title: "Documents",
    icon: FileArchive,
    tab_icon: FileArchive,
    permission: PERMISSIONS.RH.DOCUMENTS.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 24,
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
    description: "Gestion des Documents",
  },
  component: DocumentManager,
});
